export default __webpack_public_path__ + "static/media/Organization-Blue-24x24.b81171da.svg";